<template>
  <div style="height: 60px;">
    <div v-html="title" class="number-grow-warp"></div><span v-html="numberGrowNumber" :data-time="time" class="number-grow" :data-value="value">0</span><span v-html="dw" class="number-grow-dw"></span>
  </div>
</template>

<script>
  export default {
    props: {
      title:{
        type: String
      },
      dw:{
        type: String
      },
      time: {
        type: Number,
        default: 2
      },
      value: {
        type: Number,
        default: 720000
      }
    },
    data () {
      return {
        numberGrowNumber:0
      }
    },
    methods: {
      numberGrow () {
        let _this = this
        let step = (_this.value * 10) / (_this.time * 1000)
        let current = 0
        let start = 0
        let t = setInterval(function () {
          start += parseInt(step);
          if (start > _this.value) {
            clearInterval(t)
            start = _this.value
            t = null
          }
          if (current === start) {
            return
          }
          current = start
          _this.numberGrowNumber = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
        }, 10)
      }
    },
    mounted () {
      //this.numberGrow()
    }
  }
</script>
<style scoped>
  .number-grow-warp{
    font-size: 14px;
    height: 20px;
  }
  .number-grow {
    font-family: "思源黑体";
    font-size: 22px;
    color: #ffffff;
    height: 40px;
  }
  .number-grow-dw{
    height: 40px;
    vertical-align: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NumberGrow.vue